const hexToRgb = (hexColor: string) => {
  // convert short hex color to long format, #abc -> #aabbcc
  hexColor = hexColor.replace(
    /^#([0-9a-f])([0-9a-f])([0-9a-f])$/i,
    '#$1$1$2$2$3$3'
  );

  const [r = 0, g = 0, b = 0] = (
    hexColor.match(/#([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})/i) || []
  )
    .slice(1)
    .map((color) => parseInt(color, 16));

  return { r, g, b };
};

export default hexToRgb;
